/* src/app/shared/components/settings/user-setup/user-setup.component.scss */
:host ::ng-deep .p-fieldset .p-fieldset-legend {
  font-size: 1.13rem;
  font-weight: 400;
}
:host ::ng-deep .p-fieldset {
  padding: 0;
}
:host ::ng-deep .p-fieldset .p-fieldset-legend:hover {
  background: transparent;
  box-shadow: none;
}
:host ::ng-deep .user-email-inputgroup .p-floatlabel {
  flex: 1 1 auto;
}
:host ::ng-deep .user-email-inputgroup .p-inputgroup-addon,
:host ::ng-deep .user-email-inputgroup .p-button {
  min-height: 2rem;
}
:host ::ng-deep .user-email-inputgroup .p-button {
  min-width: 2rem;
}
/*# sourceMappingURL=user-setup.component.css.map */
